(() => {
  const MAX_BYTES = 10 * 1024 * 1024;

  function init(root) {
    if (root.dataset.myReady === 'true') return;
    root.dataset.myReady = 'true';

    root.querySelectorAll('[data-my-photo-input]').forEach((input) => {
      const group = input.closest('.my-upload-group');
      const preview = group?.querySelector('[data-my-preview]');
      const image = preview?.querySelector('[data-my-preview-image]');
      const name = preview?.querySelector('[data-my-preview-name]');
      const change = preview?.querySelector('[data-my-change]');
      const upload = group?.querySelector('.my-upload');
      let objectUrl = null;

      const clearPreview = () => {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = null;
        if (image) image.removeAttribute('src');
        if (name) name.textContent = '';
        if (preview) preview.hidden = true;
        if (upload) upload.hidden = false;
      };

      input.addEventListener('change', () => {
        input.setCustomValidity('');
        const file = input.files?.[0];
        if (!file) {
          clearPreview();
          return;
        }
        if (file.size > MAX_BYTES) {
          input.value = '';
          clearPreview();
          input.setCustomValidity('Please choose a photo smaller than 10 MB.');
          input.reportValidity();
          return;
        }

        clearPreview();
        objectUrl = URL.createObjectURL(file);
        if (image) image.src = objectUrl;
        if (name) name.textContent = file.name;
        if (preview) preview.hidden = false;
        if (upload) upload.hidden = true;
      });

      change?.addEventListener('click', () => input.click());
    });
  }

  const boot = () => document.querySelectorAll('[data-meet-your-customizer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();